var WaitBoardItemModel = require('../wait-board/wait-board-item');

var WaitBoardModel = Backbone.Epoxy.Model.extend({
  initialize: function() { },

  defaults: {
    isInitialized: false,
    isFeatureEnabled: false,
    isStoreConnected: false,
    hasAppointments: false,
    allMyGuestsInService: false,
    waitBoardItems: new Backbone.Collection(null, { model: WaitBoardItemModel }),
    store: {},
  },

  computeds: {
    storeHasPhone: function() {
      return this.get('store') && this.get('store').phone != null;
    },
    storeGetPhone: function() {
      return this.get('storeHasPhone') ? this.get('store').phone : null;
    },

    storeHasName: function() {
      return this.get('store') && this.get('store').name != null;
    },
    storeGetName: function() {
      return this.get('storeHasName') ? this.get('store').name : null;
    },

    storeHasAddress1: function() {
      return this.get('store') && this.get('store').address1 != null;
    },
    storeGetAddress1: function() {
      return this.get('storeHasAddress1') ? this.get('store').address1 : null;
    },

    storeHasAddress2: function() {
      return this.get('store') && this.get('store').address2 != null;
    },
    storeGetAddress2: function() {
      return this.get('storeHasAddress2') ? this.get('store').address2 : null;
    },

    storeGetGmapsHref: function() {
      var params = $.param({ daddr: this.get('store').address1 + ' ' + this.get('store').address2 });
      return "https://maps.google.com?" + params;
    },

  },

  validation: { },

  bindModel: function(data) {
    this.set('isInitialized', true);


    /// General checks
    this.get('waitBoardItems').reset();
    this.set('isFeatureEnabled', (((data || {}).waitBoardInfo || {}).settings || {}).enabled);
    this.set('isStoreConnected', ((data || {}).waitBoardInfo || {}).connected !== false);
    this.set('allMyGuestsInService', ((data || {}).waitBoardInfo || {}).allMyGuestsInService);
    var waitBoardInfo = data.waitBoardInfo;

    if (!data.success ||
      !waitBoardInfo ||
      !waitBoardInfo.store ||
      !waitBoardInfo.settings ||
      !waitBoardInfo.settings.enabled ||
      !waitBoardInfo.waitBoardItems ||
      waitBoardInfo.waitBoardItems.length == 0) {
      this.set('hasAppointments', false);
      return;
    }


    /// Wait Board Items
    var index = 0;
    var mainOrSecondaryGuestsPresent = false;
    _.each(waitBoardInfo.waitBoardItems, _.bind(function(waitBoardItem) {
      var waitBoardItemModel = new WaitBoardItemModel();
      waitBoardItemModel.bindModel(waitBoardItem, index);

      this.get('waitBoardItems').push(waitBoardItemModel);

      if (waitBoardItemModel.isMyGuestOrMyself()) {
        mainOrSecondaryGuestsPresent = true;
      }

      index ++;
    }, this));

    this.set('hasAppointments', mainOrSecondaryGuestsPresent);


    /// Store Info
    this.set('store', {
      // storeId: waitBoardInfo.store.id,
      name: waitBoardInfo.store.name,
      address1: waitBoardInfo.store.address1,
      address2: waitBoardInfo.store.address2,
      phone: waitBoardInfo.store.phone,
      // email: waitBoardInfo.store.email,
      // website: waitBoardInfo.store.website,
      // numRatings: waitBoardInfo.store.numRatings,
      // avgRating: waitBoardInfo.store.avgRating % 1 == 0.5 ? waitBoardInfo.store.avgRating : Math.round(waitBoardInfo.store.avgRating),
      // facebookUrl: waitBoardInfo.store.facebookUrl,
      // googlePlusUrl: waitBoardInfo.store.googlePlusUrl,
      // twitterUrl: waitBoardInfo.store.twitterUrl,
      // yelpUrl: waitBoardInfo.store.yelpUrl,
      // photoId: waitBoardInfo.store.photoId,
      // timezone: waitBoardInfo.store.timeZone,
      // storeLocalTime: waitBoardInfo.store.storeLocalTime
    });

  }
});

module.exports = WaitBoardModel;